import { AddCustomerEmployeeContactInput, EditCustomerEmployeeContactInput } from "../customer-employee-contact";

export class ChangePersonalInformationInput {
    public fullName: string;
    public email: string;
    public personalPictureFile: string = '';
    public personalPictureFileName: string = '';
    public addCustomerEmployeeContacts: Array<AddCustomerEmployeeContactInput> = [];
    public editCustomerEmployeeContacts: Array<EditCustomerEmployeeContactInput> = [];
    public deleteCustomerEmployeeContacts: Array<number> = [];

    constructor() {
        this.fullName = '';
        this.email = '';
    }
}
